"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffScanQrModel = instanceOfLiffScanQrModel;
exports.LiffScanQrModelFromJSON = LiffScanQrModelFromJSON;
exports.LiffScanQrModelFromJSONTyped = LiffScanQrModelFromJSONTyped;
exports.LiffScanQrModelToJSON = LiffScanQrModelToJSON;
exports.LiffScanQrModelToJSONTyped = LiffScanQrModelToJSONTyped;
/**
 * Check if a given object implements the LiffScanQrModel interface.
 */
function instanceOfLiffScanQrModel(value) {
    if (!('qrData' in value) || value['qrData'] === undefined)
        return false;
    return true;
}
function LiffScanQrModelFromJSON(json) {
    return LiffScanQrModelFromJSONTyped(json, false);
}
function LiffScanQrModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'qrData': json['qrData'],
        'lineId': json['lineId'] == null ? undefined : json['lineId'],
        'lineUserName': json['lineUserName'] == null ? undefined : json['lineUserName'],
    };
}
function LiffScanQrModelToJSON(json) {
    return LiffScanQrModelToJSONTyped(json, false);
}
function LiffScanQrModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'qrData': value['qrData'],
        'lineId': value['lineId'],
        'lineUserName': value['lineUserName'],
    };
}
